import { render, staticRenderFns } from "./ManageDeliveryCost.vue?vue&type=template&id=d8ab5aa4&"
import script from "./ManageDeliveryCost.vue?vue&type=script&lang=js&"
export * from "./ManageDeliveryCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports